import styled from 'styled-components'

export const AuditPointNumberWrapper = styled.div`
  background-color: var(--tds-white);
  display: flex;
  padding: var(--tds-spacing-element-16) var(--tds-spacing-element-32) 0;
`

export const AuditPointNumber = styled.h6`
  margin: 0 var(--tds-spacing-element-16) 0 0;
`

export const StyledSpan = styled.span`
  > :first-child {
    margin-top: 0;
  }
`
